import {
  PRESENCE
} from '../../config/constants'

export default (presence) => {
  if (typeof presence !== 'number') return false

  if (presence === PRESENCE.ONLINE || presence === PRESENCE.AWAY) return true

  return false
}




/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/is_available_for_immediate_session.js
 **/